export const payments = ['Insured', 'Self pay', 'Not sure'];
